<template>
  <div>
    <a-card v-show="!shrink" class="version-list" size="small" :loading="loading">
      <span slot="title">
        <a v-dis="{ code: 'project:version:create', project: projectId }" class="handle-menu" type="link" @click="onAdd"> <a-icon type="plus" /> 添加迭代</a>
      </span>
      <span slot="extra">
        <version-filter @filter="getVersionList" />
      </span>
      <div class="version-content">
        <template v-for="version in versionData">
          <a-card :key="version.id" hoverable :class="versionCardClass(version.id)" @click="onSelect(version)">
            <div class="left-avatar">
              <a-avatar shape="square" :size="48" :src="version.creator.avatar_url || null" />
            </div>
            <div class="right-content">
              <div class="version-title">{{ version.title }}</div>
              <div class="version-time">{{ `${version.pre_start_time} ~ ${version.pre_end_time}` }}</div>
              <div><a-progress :percent="progress(version.progress)" size="small" /></div>
            </div>
          </a-card>
        </template>
      </div>
    </a-card>
    <div class="shrink" @click="switchShrink">
      <a-icon class="shrink-icon" :type="shrink === false ? 'left' : 'right'" />
    </div>
    <version-edit ref="versionEditRef" @close="close" />
  </div>
</template>

<script>
import { versionList } from '@/api/project/version';
import VersionEdit from '@/pages/project/version/components/VersionEdit';
import VersionFilter from '@/pages/project/version/components/VersionFilter';

export default {
  components: { VersionEdit, VersionFilter },
  data() {
    return {
      loading: true,
      shrink: false,
      versionData: [],
      currentVersionId: parseInt(this.$route.query.version_id) || null,
      projectId: parseInt(this.$route.params.project_id) || 0,
      filterForm: {
        status: [0],
        page_size: null,
        page_number: 1
      }
    };
  },

  computed: {
    versionCardClass() {
      return value => {
        return this.currentVersionId === value ? 'version-card version-card_selected' : 'version-card';
      };
    },
    progress() {
      return p => {
        let count = 0;
        let completed = 0;
        if (p === null) {
          return 0;
        }
        for (const item in p) {
          count += p[item];
          if (item === '7') {
            completed += p[item];
          }
        }
        return completed === 0 ? completed : Math.round((completed / count) * 100);
      };
    }
  },

  watch: {
    currentVersionId() {
      if (this.currentVersionId) {
        this.$router.push({
          name: 'page:project:version',
          query: {
            version_id: this.currentVersionId
          }
        });
      }
    },
    $route() {
      this.currentVersionId = parseInt(this.$route.query.version_id) || null;
      if (this.currentVersionId === null) {
        this.getVersionList();
      }
    }
  },

  created() {
    this.getVersionList();
  },

  methods: {
    getVersionList(filter = null) {
      this.loading = true;
      if (filter !== null) {
        this.filterForm = { ...filter };
      }
      versionList({ project_id: this.projectId, ...this.filterForm })
        .then(res => {
          this.versionData = [
            ...res.data.list,
            {
              id: -1,
              title: '需求池',
              avatar_url: '',
              creator: {
                avatar_url: 'https://devops-resource.cdfsunrise.com/static/202209192158503019.png'
              },
              pre_end_time: '',
              pre_start_time: '',
              progress: { 9: 0 }
            }
          ];
          if (this.currentVersionId === null) {
            this.currentVersionId = this.versionData[0].id;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onSelect(record) {
      this.currentVersionId = record.id;
    },

    onAdd() {
      this.$refs['versionEditRef'].onOpen(null, {});
    },

    close() {
      this.getVersionList();
    },
    switchShrink() {
      this.shrink = !this.shrink;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.version-list {
  margin-left: 16px;
  min-width: 266px;
  height: calc(~'100vh - 120px');
  float: left;

  .version-content {
    height: calc(~'100vh - 196px');
    overflow: auto;
  }
  .ant-card-body {
    padding: 12px;
  }
  .version-card {
    cursor: pointer;
    margin-bottom: 12px;
    .left-avatar {
      padding-top: 6px;
      float: left;
      width: 54px;
    }
    .right-content {
      float: right;
      width: 160px;
      .version-title {
        font-weight: bold;
        line-height: 24px;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 1; /**显示的行数**/
        overflow: hidden; /**隐藏超出的内容**/
      }
      .version-time {
        font-size: 12px;
        line-height: 16px;
        color: #8c95a8;
      }
    }
  }

  .version-card:hover,
  .version-card_selected {
    border: 1px solid #1890ff;
  }
}
.shrink {
  margin-top: calc(~'50vh - 88px');
  width: 14px;
  height: 48px;
  border: 1px solid #e5e5e5;
  border-left: 0px;
  float: left;
  background-color: #fff;
  border-radius: 0 6px 6px 0;
  .shrink-icon {
    color: #e5e5e5;
    line-height: 48px;
    font-size: 12px;
    font-weight: bold;
  }
}
.shrink:hover {
  background-color: #1890ff;
  border: 1px solid #1890ff;
  .shrink-icon {
    color: #fff;
  }
}
</style>
